import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoHeart = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Heart</title>
    <path
      d="m16.39 27.445-.01.008c-.199.15-.593.155-.793.02l-.04-.03-.171-.136a297.354 297.354 0 0 1-2.565-2.052c-1.495-1.212-3.004-2.47-3.42-2.922-.191-.205-.437-.45-.723-.736-.751-.748-1.777-1.77-2.78-3.062-1.376-1.769-2.51-3.814-2.597-5.863-.155-3.65 3.081-7.102 6.834-7.102 1.473 0 2.599.327 3.914 1.297.19.14.486.414.766.69a21.765 21.765 0 0 1 .435.44l.026.027.006.007.001.001.74.781.725-.793v-.001l.006-.006.023-.025.088-.094c.078-.081.186-.194.312-.32.261-.26.56-.535.79-.705 1.323-.968 2.447-1.299 3.917-1.299 3.753 0 6.988 3.453 6.835 7.102-.087 2.06-1.15 4.021-2.476 5.736-.957 1.237-1.96 2.241-2.765 3.047-.323.323-.614.615-.857.876-.405.436-1.917 1.687-3.421 2.895a275.041 275.041 0 0 1-2.582 2.049l-.172.135-.045.035Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoHeart;
